<script>
	import { navigate } from "svelte-routing";
	import { imageLightbox } from "../../../../../store/store";
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import CustomPaginate from "../../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../../components/Loader/LoaderContainer.svelte";
	import FontAwesomeIcon from "src/components/FontAwesomeIcon/FontAwesomeIcon.svelte";
	import { faPaperclip as fasPaperclip } from "@fortawesome/free-solid-svg-icons";
	import { convert } from "../../../../../services/helpers";
	import {
		VehicleReportSectionOptions,
		cmmDamageTypeOptions,
		VehicleCarSectionOptions,
		cmmRejectReasonOptions,
	} from "../../../../../utils/options";

	export let data;
	export let handleStatus;

	//lightbox with image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";
	import TableDropdown from "../../../../../components/TableDropdown/TableDropdown.svelte";

	let modalOpen = false;

	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		imageLightbox.set(i);
		imageShowingIndex = 0;
		modalOpen = true;
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle No.</th>
				<th>Damage Area</th>
				<th>Damage Type</th>
				<th>Report Section</th>
				<th>Photos/Videos</th>
				<th>Reject Reason</th>
				<th>Date Reported</th>
				<th>Date Modified</th>
				<th>Source</th>
				<th>Status</th>
				<th>Action</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { vehicleId, reportSection, plateNumber, carSection, damageType, imageUrls, createdAt, updatedAt, originType, rejectReason, id }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
						>
							<span class="link-text">
								{plateNumber}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{VehicleCarSectionOptions[carSection] !=
								undefined
									? VehicleCarSectionOptions[carSection].label
									: undefined}
							</span>
						</p>
					</td>
					<td>
						{cmmDamageTypeOptions[damageType] != undefined
							? cmmDamageTypeOptions[damageType].label
							: "NA"}
					</td>
					<td>
						{VehicleReportSectionOptions[reportSection] != undefined
							? VehicleReportSectionOptions[reportSection].label
							: undefined}
					</td>
					<td>
						<h4 class="">
							&nbsp;&nbsp;
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<!-- svelte-ignore a11y-interactive-supports-focus -->
							<button
								type="button"
								style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
								on:click={() => handleImgClick(imageUrls)}
							>
								<FontAwesomeIcon icon={fasPaperclip} />
							</button>
						</h4>
					</td>
					<td>
						{cmmRejectReasonOptions[rejectReason] != undefined
							? cmmRejectReasonOptions[rejectReason].label
							: undefined}
					</td>
					<td>
						{convert(createdAt)}
					</td>
					<td>
						{#if updatedAt}
							{convert(updatedAt)}
						{:else}
							Never
						{/if}
					</td>
					<td>
						{#if originType === 0}
							FMS
						{:else if originType === 1}
							CMS
						{/if}
					</td>
					<td>
						<p class="status-bar status-bar-3">Rejected</p>
					</td>
					<td>
						<TableDropdown>
							<DropdownItem on:click={() => handleStatus(id)}
								>Set to Pending Review</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
